import React from 'react';
import FormLabel from '../../../../components/form/label/label';
import TextField from '../../../../components/form/text-field/text-field';
import { Desktop, Mobile } from '../../../../app-responsive';
import './additional-licences.css';

const AdditionalLicences = (props) => {
  const { additionalLicencesDetails, additionalLicencesQuantity, usersOrLicencesFormField, handleOnBlur, handleOnChange } = props;
  const additionalLicensesWithoutOther = additionalLicencesDetails.filter(license => license.key !== 'cancel');
  const additionalLicensesHeadings = additionalLicensesWithoutOther.map(additionalLicencesDetail => (
    <div className="col-md-3 pl-sm-0 additional-licences-item" key={`id-${additionalLicencesDetail.key}`}>
      <FormLabel label={additionalLicencesDetail.value} forId={additionalLicencesDetail.key} />
    </div>
  ));
  const additionalLicensesTextFields = additionalLicensesWithoutOther.map(additionalLicencesDetail => (
    <div className="col-md-3 pl-sm-0 additional-licences-item" key={`id-${additionalLicencesDetail.key}`}>
      <TextField
        label={usersOrLicencesFormField.label}
        id={additionalLicencesDetail.key}
        placeholder={usersOrLicencesFormField.placeholder}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        value={additionalLicencesQuantity[additionalLicencesDetail.key]}
      />
    </div>
  ));

  const additionalLicensesMobile = additionalLicensesWithoutOther.map(additionalLicencesDetail => (
    <div className="col-md-3 pl-sm-0 additional-licences-item" key={`id-${additionalLicencesDetail.key}`}>
      <div className="row">
        <div className="col-12 pl-sm-0">
          <FormLabel label={additionalLicencesDetail.value} forId={additionalLicencesDetail.key} />
        </div>
        <div className="col-5 pl-sm-0">
          <TextField
            label={usersOrLicencesFormField.label}
            id={additionalLicencesDetail.key}
            placeholder={usersOrLicencesFormField.placeholder}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            value={additionalLicencesQuantity[additionalLicencesDetail.key]}
          />
        </div>
      </div>
    </div>
  ));

  return (
    <React.Fragment>
      <div className="row additional-licences-section">
        <Desktop>
          {additionalLicensesHeadings}
          {additionalLicensesTextFields}
        </Desktop>
        <Mobile>
          {additionalLicensesMobile}
        </Mobile>
      </div>
    </React.Fragment>
  );
};

export default AdditionalLicences;
